/**
 * Índices de reajuste. Espelha PriceIndex do backend — a série do BCB fica lá, aqui só o rótulo.
 */
export enum PriceIndex {
    ipca = 'ipca',
    igpm = 'igpm',
}

export const PriceIndexFriendly: Record<string, string> = {
    ipca: 'IPCA',
    igpm: 'IGP-M',
}

// periodicidade é lei (10.192/2001), não preferência: por isso é constante e não campo
export const PRICE_ADJUSTMENT_MIN_MONTHS = 12

export class PriceAdjustmentConfigDto {
    priceAdjustmentAuto: boolean
    priceAdjustmentIndex?: PriceIndex
}

export class ApplyPriceAdjustmentDto {
    index?: PriceIndex
    // percentual editado pelo operador; sem ele vale o do índice
    percent?: number
    simulation?: boolean
}

export class PriceAdjustmentPreviewDto {
    allowed: boolean
    reason?: string
    monthsSinceLast: number
    // passou mais tempo do que os 12 meses que a janela do índice cobre
    windowShorterThanElapsed: boolean

    index?: PriceIndex
    percentSuggested?: number
    windowStart?: string
    windowEnd?: string

    currentValue: number
    newValue?: number

    chargesToUpdate: { chargeId: string; dueDate: Date; value: number; newValue: number }[]
    chargesUntouched: { chargeId: string; dueDate: Date; value: number; daysToDue: number }[]
}

export class RevertPriceAdjustmentPreviewDto {
    allowed: boolean
    // existe algum reajuste aplicado? falso esconde o bloco inteiro na tela, em vez de anunciar
    // uma acao que nao tem objeto
    hasAdjustment: boolean
    reason?: string
    appliedAt?: Date
    percent?: number
    currentValue: number
    restoredValue?: number
    chargesToRestore: { chargeId: string; dueDate: Date; value: number; restoredValue: number }[]
    // já saíram para o gateway: nenhum update local desfaz boleto emitido ou pix pago
    chargesNotRestorable: { chargeId: string; dueDate: Date; value: number; statusLabel: string }[]
}
